import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Calculatrice de temps d'apprentissage de l'allemand - Estimez votre parcours CECRL";
const DESCRIPTION =
  "Calculatrice de temps d'apprentissage de l'allemand - Estimez votre parcours CECRL. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "german learning time calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/german-learning-time-calculator/";

const GermanLearningTimeCalculator = () => {
  const [lessonsPerWeek, setLessonsPerWeek] = useState("");
  const [lessonTime, setLessonTime] = useState("");
  const [timeUnit, setTimeUnit] = useState("minutes");
  const [timeFormat, setTimeFormat] = useState("weeks");
  const [totalWeeklyHours, setTotalWeeklyHours] = useState("");
  const [timeToLevels, setTimeToLevels] = useState({});
  const [error, setError] = useState("");

  const LEVELS = {
    A1: 100,
    A2: 200,
    B1: 350,
    B2: 600,
    C1: 750,
    C2: 1000,
  };

  const calculateTotalHours = (lessons, time, unit) => {
    const timeInHours = unit === "minutes" ? parseFloat(time) / 60 : parseFloat(time);
    return parseFloat(lessons) * timeInHours;
  };

  const calculateTimeForLevels = (weeklyHours) => {
    let result = {};
    let accumulated = 0;
    Object.entries(LEVELS).forEach(([level, hours]) => {
      accumulated += hours;
      result[level] = formatTime(accumulated / weeklyHours);
    });
    return result;
  };

  const formatTime = (weeks) => {
    switch (timeFormat) {
      case "days": return (weeks * 7).toFixed(1) + " jours";
      case "months": return (weeks / 4).toFixed(1) + " mois";
      case "years": return (weeks / 52).toFixed(1) + " ans";
      default: return weeks.toFixed(1) + " semaines";
    }
  };

  const handleCalculate = () => {
    try {
      if (!lessonsPerWeek || !lessonTime) {
        throw new Error("Veuillez entrer le nombre de cours par semaine et la dure moyenne d'un cours.");
      }
      const lessonTimeValue = lessonTime.includes(":")
        ? parseFloat(lessonTime.split(":")[0]) + parseFloat(lessonTime.split(":")[1]) / 60
        : parseFloat(lessonTime);
      const totalHours = calculateTotalHours(parseFloat(lessonsPerWeek), lessonTimeValue, timeUnit);
      setTotalWeeklyHours(totalHours.toFixed(2) + " heures/semaine");
      setTimeToLevels(calculateTimeForLevels(totalHours));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice estime le temps ncessaire pour atteindre chaque niveau du Cadre Europen
                  Commun de Rfrence (CECRL) en allemand, en fonction de votre rythme d'tude hebdomadaire.
                  L'allemand est considr comme une langue de difficult leve pour les non-germaniques.
                </p>
                <p>
                  Le temps rel varie selon votre langue maternelle, votre exposition quotidienne  la langue,
                  l'intensit de vos tudes et la mthode pdagogique utilise. Ces estimations sont indicatives.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculatrice de temps d'apprentissage de l'allemand</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Cours par semaine</label></b>
                    <input
                      type="number"
                      placeholder="Ex : 5"
                      value={lessonsPerWeek}
                      onChange={(e) => setLessonsPerWeek(e.target.value)}
                      className="form-control"
                      style={{ width: "50%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Dure du cours</label></b>
                    <input
                      type="text"
                      placeholder="Ex : 60"
                      value={lessonTime}
                      onChange={(e) => setLessonTime(e.target.value)}
                      className="form-control"
                      style={{ width: "40%" }}
                    />
                    <select
                      value={timeUnit}
                      onChange={(e) => setTimeUnit(e.target.value)}
                      className="form-select ms-2"
                      style={{ width: "25%" }}
                    >
                      <option value="minutes">Minutes</option>
                      <option value="hours">Heures</option>
                    </select>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Format des rsultats</label></b>
                    <select
                      value={timeFormat}
                      onChange={(e) => setTimeFormat(e.target.value)}
                      className="form-select ms-2"
                      style={{ width: "25%" }}
                    >
                      <option value="days">Jours</option>
                      <option value="weeks">Semaines</option>
                      <option value="months">Mois</option>
                      <option value="years">Ans</option>
                    </select>
                  </div>
                  <br />
                  <button className="btn btn-success" style={{ fontSize: "20px" }} onClick={handleCalculate}>
                    Calculer
                  </button>
                  <br />
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  <br />
                  {totalWeeklyHours && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <hr />
                      <p>Rsultats :</p>
                      <p>Total heures hebdomadaires : <b>{totalWeeklyHours}</b></p>
                      <p><b>{timeToLevels.A1}</b>  du niveau A1  A2</p>
                      <p><b>{timeToLevels.A2}</b>  du niveau A2  B1</p>
                      <p><b>{timeToLevels.B1}</b>  du niveau B1  B2</p>
                      <p><b>{timeToLevels.B2}</b>  du niveau B2  C1</p>
                      <p><b>{timeToLevels.C1}</b>  du niveau C1  C2</p>
                      <p><b>{timeToLevels.C2}</b>  temps total de A1  C2</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Quels sont les niveaux CECRL pour l'allemand ?</h2>
              </div>
              <div className="info-section-body">
                <p>L'Institut Goethe et le CECRL dfinissent 6 niveaux pour l'allemand :</p>
                <ul>
                  <li><strong>A1 (Dbutant) :</strong> Expressions quotidiennes simples, prsentations de base.</li>
                  <li><strong>A2 (lmentaire) :</strong> Communication sur des sujets familiers, besoins immdiats.</li>
                  <li><strong>B1 (Intermdiaire) :</strong> Comprhension des situations courantes au travail et en voyage.</li>
                  <li><strong>B2 (Intermdiaire suprieur) :</strong> Expression spontane avec des germanophones natifs.</li>
                  <li><strong>C1 (Avanc) :</strong> Utilisation fluide et flexible pour des besoins sociaux et professionnels.</li>
                  <li><strong>C2 (Matrise) :</strong> Comprhension et expression quasi parfaites  l'crit et  l'oral.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Combien d'heures faut-il pour apprendre l'allemand ?</h2>
              </div>
              <div className="info-section-body">
                <p>Voici une estimation des heures cumules ncessaires pour chaque niveau d'allemand :</p>
                <table className="table bmi-table">
                  <thead>
                    <tr>
                      <th className="bmi-header">Niveau</th>
                      <th className="bmi-header">Heures cumules</th>
                      <th className="bmi-header">Heures pour ce palier</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>A1 ? A2</td><td>100 h</td><td>100 h</td></tr>
                    <tr><td>A2 ? B1</td><td>300 h</td><td>200 h</td></tr>
                    <tr><td>B1 ? B2</td><td>650 h</td><td>350 h</td></tr>
                    <tr><td>B2 ? C1</td><td>1 250 h</td><td>600 h</td></tr>
                    <tr><td>C1 ? C2</td><td>2 000 h</td><td>750 h</td></tr>
                    <tr><td><strong>Total A1 ? C2</strong></td><td><strong>3 000 h</strong></td><td></td></tr>
                  </tbody>
                </table>
                <p>L'allemand est rput difficile en raison de ses dclinaisons, ses 4 cas grammaticaux, ses genres (masculin, fminin, neutre) et la construction particulire de ses phrases.</p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Pourquoi apprendre l'allemand ?</h2>
              </div>
              <div className="info-section-body">
                <ul>
                  <li><strong>conomie puissante :</strong> l'Allemagne est la premire conomie d'Europe et la quatrime mondiale. Parler allemand ouvre des opportunits professionnelles majeures.</li>
                  <li><strong>Langue scientifique :</strong> l'allemand est une langue cl dans les domaines de l'ingnierie, de la chimie et de la philosophie.</li>
                  <li><strong>Culture riche :</strong> accdez  Goethe, Nietzsche, Beethoven et  une littrature et une musique classique inestimables.</li>
                  <li><strong>tudes :</strong> de nombreuses universits allemandes proposent des formations gratuites ou peu coteuses aux tudiants internationaux.</li>
                  <li><strong>Voyage :</strong> essentiel en Allemagne, Autriche, Suisse et Liechtenstein.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Conseils pour apprendre l'allemand efficacement</h2>
              </div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Matrisez les cas grammaticaux tt :</strong> nominatif, accusatif, datif et gnitif sont fondamentaux. Apprenez-les ds le dbut.</li>
                  <li><strong>Apprenez les genres avec les mots :</strong> mmorisez  der/die/das  avec chaque nouveau substantif.</li>
                  <li><strong>Pratiquez avec des natifs :</strong> les tandem linguistiques sont trs efficaces pour progresser rapidement.</li>
                  <li><strong>Consommez des mdias allemands :</strong> podcasts Deutsche Welle, chanes YouTube, ZDF Mediathek.</li>
                  <li><strong>Passez des certifications :</strong> TestDaF, DSH ou le Goethe-Zertifikat sont reconnus internationalement.</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default GermanLearningTimeCalculator;
